import React, { useEffect, useState } from 'react';
import { states } from '../../consts/states';
import { TOP_CITIES } from '../../consts/top-cities';
import { escapeString } from '../../helpers/escape-string';
import { cityLink, stateLink, toColumns } from '../../helpers/column-view';
import './top-list.scss';

export const RenderTopCities = ({ isMobile, SSR }) => {
    const [myCols, setMyCols] = useState(toColumns(TOP_CITIES, 2));

    useEffect(() => {
        !isMobile && setMyCols(toColumns(TOP_CITIES, 5));
    }, [isMobile]);

    return (
        <div className="sniff-top-listings">
            <div className="l-container b-bot">
                <h3 className="snif-m2 snif-medium mb-2">Browse by top cities</h3>
                <div className="top-list-box">
                    {myCols.map((col, i) => (
                        <div key={i} className="snif-p text-dark">
                            {col.map((c, j) => cityLink(c.city || c.name, c.url, j, SSR))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export const RenderTopState = ({ isMobile, SSR }) => {
    const [myCols, setMyCols] = useState(toColumns(states, 2));

    useEffect(() => {
        !isMobile && setMyCols(toColumns(states, 5));
    }, [isMobile]);

    return (
        <div className="sniff-top-listings">
            <div className="l-container b-bot">
                <h3 className="snif-m2 snif-medium mb-2">Browse by state</h3>
                <div className="top-list-box">
                    {myCols.map((col, i) => (
                        <div key={i} className="snif-p text-dark">
                            {col.map((c, j) => stateLink(c, escapeString(c), j, SSR))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
